<template>
    <div>
        <!-- Tiểu đề trang -->
        <div class="primarylists list-mobile" v-if="!mobile">
            <div class="titles clear" id="explore">
                <img src="../../../static/images/icon-st.jpg" />
                <div class="title l title-flex">
                    <span style="text-transform: uppercase !important;">{{ $t("manage.student") }}</span>
                </div>
            </div>
        </div>

        <!-- Nội dung -->
        <div class="manage--main" ref="manageStudents">

            <!-- Header Mobile -->
            <div class="header-manage">
                <div class="header-content" v-if="mobile">
                    <button v-if="showDetail && !menu" @click="back()"></button>
                    <div class="user-name">
                        <template v-if="itemActive != null && itemActive.userName.search('@') !== -1">{{itemActive.userName.substring(0, itemActive.userName.search('@'))}}</template>
                        <template v-if="itemActive != null && itemActive.userName.search('@') == -1">{{itemActive.userName}}</template>
                    </div>
                </div>

                <!-- Toogle tab mobile -->
                <div class="icon-img-right" @click="toogleMenu()">
                    <img v-if="menu" src="../../../static/images/khoahoccuatoi-trang.png" />
                    <img v-else :src="$CONST.HEADER.IMG.SEARCH" />
                </div>
            </div>
            
            <!-- left -->
            <left v-on:toogleStudent="toogleStudent($event)"></left>

            <!-- main -->
            <contentManage v-if="loading" :data="itemActive"></contentManage>
        </div>

        <!-- Loading -->
        <loading class="loading--lesson" :showLoading="loadingStudent"/>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import left from "@/components/manage/left/students";
    import contentManage from "@/components/manage/content/students";
    import loading from "@/components/loading/loading";

    export default {
        name: "manageStudent",
        data() {
            return {
                itemActive: null,
                menu: false,
                loading: false
            };
        },
        components: {
            left,
            contentManage,
            loading,
        },
        computed: {
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
                showDetail: (state) => state.manageStudent.showDetail,
                showWrongAnswer: (state) => state.manageDetail.showWrongAnswer,
                loadingStudent: (state) => state.manageStudent.loadingStudent
            }),
        },
        methods: {

            // Ẩn/Hiện menu
            toogleMenu: function () {
                this.menu = !this.menu;
                document.getElementsByTagName("body")[0].classList.toggle("show-menu-1");
            },

            // Thay đổi học viên
            toogleStudent: function (data) {
                if (data) {
                    this.itemActive = data;
                    this.menu = false;
                    this.loading = false;

                    this.$nextTick(() => {
                        this.loading = true;
                    });
                } else {
                    this.$alert(window.vm.$i18n.t("new.title93"), "", {
                        confirmButtonText: window.vm.$i18n.t("js.confirm"),
                    }).then(() => {
                        window.history.go(-1);
                    });
                }
            },

            // back
            back: function () {
                if (this.showWrongAnswer) {
                    this.setShowWrongAnswer(false);
                } else {
                    this.setShowDetail(false);
                }
            },

            // vuex
            ...mapMutations("manageStudent", ["setShowDetail"]),
            ...mapMutations("manageDetail", ["setShowWrongAnswer"]),
            
        },
    };
</script>
<style scoped>
    .exam_btn.btn-login.disable {
        background: #d2d2d2 !important;
        cursor: no-drop;
    }
    .primarylists {
        margin-top: 15px !important;
        margin:0 auto;
        max-width: 1200px;
        width: 100%;
    }
    .nameStudent {
        color: #da251d;
    }
    .user-name {
        margin-left: 4px;
    }
    .user-name.ml {
        margin-left: 50px;
    }
    .header-content {
        display: flex;
    }
    .header-content button {
        background: url(/static/images/back.png) no-repeat!important;
        width: 50px!important;
        height: 60px;
        border: 0!important;
        cursor: pointer;
        align-self: center;
    }
    .user-name {
        font-weight: bold;
        padding: 0 5px;
        text-transform: uppercase;
        font-size: 18px;
        color: #fff;
        margin-left: 4px;
        align-self: center;
    }
    .title-flex {
        display: flex;
        align-items: center;
    }
    .new-btn {
        margin: 0 0px 0 10px !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/manage/students.vue